import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useModel from './use-model';
import UtmCookie from '../../cookieFactory/UtmCookie';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

export const PromoCodeContext = React.createContext();

export const PromoCodeProvider = ({ children }) => {
  const { prismicPromosModel } = useModel();
  const promoCodes = prismicPromosModel?.items || [];
  const [promoCodeState, setPromoCodeState] = useState({ promoCodes, activePromo: null });

  useEffect(() => {
    if (!isEmpty(promoCodes)) {
      const utmParams = new UtmCookie().get();

      if (utmParams) {
        const activePromo = promoCodes.find(promo => (
          isEqual(JSON.parse(promo.overrideReference), utmParams)
        ));
        setPromoCodeState({ ...promoCodeState, activePromo });
      }
    }
  }, []);

  return (
    <PromoCodeContext.Provider value={promoCodeState}>
      {children}
    </PromoCodeContext.Provider>
  );
};

PromoCodeProvider.propTypes = {
  children: PropTypes.node,
};
